
<div
  :class="['consent-node-label', { 'consent-node-label--clickable': isClickable }]"
  @click="handleClick"
  @keydown.enter="handleClick"
  @keydown.space.prevent="handleClick"
  :tabindex="isClickable ? 0 : -1"
  :role="isClickable ? 'button' : undefined"
  :aria-label="ariaLabel"
>
  <v-icon
    :class="iconColorClass"
    small
  >
    {{ node.icon }}
  </v-icon>
  <v-tooltip bottom :disabled="!isTruncated">
    <template v-slot:activator="{ on, attrs }">
      <span
        ref="labelText"
        class="consent-node-label__text"
        v-bind="attrs"
        v-on="on"
      >
        {{ node.name }}
      </span>
    </template>
    <span>{{ node.name }}</span>
  </v-tooltip>
</div>
